<template>
    <nav class="flex flex-col ml-2 pr-2 bg-base-100">
        <div class="navbar md:flex-row container mx-auto px-4 md:px-20">
            <div class="flex-grow-0 mr-5">
                <a href="/" class="btn btn-ghost uppercase text-xl hover:bg-base-100">Kolireg</a>
            </div>
            <div class="flex flex-row flex-grow">
                <div
                    v-if="user && user.permissions"
                    class="flex flex-row flex-grow justify-start text-m"
                >
                    <a
                        v-if="user.permissions.find((p) => p === 'reservations::import')"
                        :class="currentTab === '/admin' ? 'active' : ''"
                        class="menu-item"
                        href="/admin"
                        >Admin</a
                    >
                    <a
                        v-if="user.permissions.find((p) => p === 'semesters::view')"
                        :class="currentTab === '/admin/semesters' ? 'active' : ''"
                        class="menu-item"
                        href="/admin/semesters"
                        >Szemeszterek</a
                    >
                    <a
                        v-if="user.permissions.find((p) => p === 'periods::view')"
                        :class="currentTab === '/admin/periods' ? 'active' : ''"
                        class="menu-item"
                        href="/admin/periods"
                        >Foglalási időszakok</a
                    >
                    <a
                        v-if="user.permissions.find((p) => p === 'articles::view')"
                        :class="currentTab === '/admin/articles' ? 'active' : ''"
                        class="menu-item"
                        href="/admin/articles"
                        >Hírek</a
                    >
                </div>
                <div v-else class="flex-grow justify-start"></div>
                <div class="flex-none mr-3">
                    <div
                        v-if="user && user.room_number"
                        class="cursor-pointer text-base"
                        @click="openRoom()"
                    >
                        Lefoglalt szoba:
                        <span class="font-bold italic">{{ user.room_number }}</span>
                    </div>
                </div>
                <div v-if="user" class="dropdown dropdown-end">
                    <label tabindex="0" class="btn btn-ghost btn-circle avatar">
                        <div class="w-10 rounded-full bg-primary relative">
                            <div
                                class="text-base mx-auto absolute top-1/2 left-1/2"
                                style="transform: translate(-50%, -50%)"
                            >
                                {{ initials }}
                            </div>
                        </div>
                    </label>
                    <ul
                        tabindex="0"
                        class="mt-3 p-2 shadow menu menu-compact dropdown-content bg-base-100 rounded-box w-52"
                    >
                        <li v-if="user.is_admin" class="lg:hidden">
                            <a
                                :class="currentTab === '/admin' ? 'active' : ''"
                                class="btn btn-ghost"
                                href="/admin"
                                >Admin</a
                            >
                        </li>
                        <li v-if="user.is_admin" class="lg:hidden">
                            <a
                                :class="currentTab === '/admin/semesters' ? 'active' : ''"
                                class="btn btn-ghost"
                                href="/admin/semesters"
                                >Szemeszterek</a
                            >
                        </li>
                        <li v-if="user.is_admin" class="lg:hidden">
                            <a
                                :class="currentTab === '/admin/periods' ? 'active' : ''"
                                class="btn btn-ghost"
                                href="/admin/periods"
                                >Foglalási időszakok</a
                            >
                        </li>
                        <li>
                            <button @click="logout(csrf)" class="btn btn-ghost">Kijelentkezés</button>
                        </li>
                    </ul>
                </div>
                <div v-else>
                    <label tabindex="0">
                        <div class="text-2xl mx-auto">
                            <a href="/login">Belépés</a>
                        </div>
                    </label>
                </div>
            </div>
        </div>
    </nav>
</template>

<script>
import { mapActions, mapState } from 'vuex';

export default {
    name: 'Navbar',
    props: ['csrf'],
    computed: {
        ...mapState('User', { user: (state) => state.user }),
        initials() {
            return this.user?.lastname.substring(0, 1) + this.user?.firstname.substring(0, 1);
        },
        currentTab() {
            return window.location.pathname;
        },
    },
    methods: {
        ...mapActions('User', ['logout']),
        ...mapActions('Room', ['switchFloor']),
        ...mapActions('Popup', ['selectRoom']),
        openRoom() {
            if (this.user.room_number) {
                this.selectRoom(this.user.room_number);
                this.switchFloor(this.user.room_number[0]);
            }
        },
    },
};
</script>

<style scoped></style>
